import { observer } from 'mobx-react-lite'
import { Select } from 'blaze-ui/Select/Select'
import { Item } from '@react-stately/collections'
import { TextInputField } from 'components/Form/TextInputField'
import { ShopifyBlog } from 'api/clients/BlogMetadataRecordsClient'
import Styles from '../../../BlogMetadata.module.scss'
import { TextFieldSize } from 'components/Form/useTextFieldCounter'

type ShopifyBlogSelectProps = {
  blogs: ShopifyBlog[]
  selectedBlogId: string | undefined
  onBlogSelect: (blogId: string) => void
  placeholder?: string
  disabled?: boolean
  size?: TextFieldSize
}

export const ShopifyBlogSelect = observer(
  ({
    blogs,
    selectedBlogId,
    onBlogSelect,
    placeholder = 'Select a blog',
    disabled = false,
    size = 'lg',
  }: ShopifyBlogSelectProps) => {
    const isEmpty = blogs.length === 0
    const isSingleBlog = blogs.length === 1

    // Auto-select single blog
    if (isSingleBlog) {
      const singleBlog = blogs[0]
      if (selectedBlogId !== singleBlog.id) {
        onBlogSelect(singleBlog.id)
      }

      return (
        <TextInputField
          wrapperClassName={Styles.inputField}
          label="Blog"
          value={singleBlog.name}
          onChange={() => {}}
          size={size}
          labelClassName={Styles.textFieldLabel}
          isReadOnly
          isDisabled={disabled}
        />
      )
    }

    // Auto-select first blog when multiple blogs are available and none is selected
    if (blogs.length > 1 && !selectedBlogId) {
      const firstBlog = blogs[0]
      onBlogSelect(firstBlog.id)
    }

    return (
      <Select
        placeholder={isEmpty ? 'No blogs available' : placeholder}
        selectedKey={selectedBlogId}
        onSelectionChange={(key) => onBlogSelect(key as string)}
        isDisabled={isEmpty || disabled}
        useButtonWidth={true}
        useFullWidth={true}
        variant="secondary"
        size={size}
      >
        {blogs.map((blog) => (
          <Item key={blog.id} textValue={blog.name}>
            {blog.name}
          </Item>
        ))}
      </Select>
    )
  },
)
